module.exports = __webpack_public_path__ + "static/media/tree_center.2d28661e.svg";